import api from "../security/api";

const haircuts = (instance, assetExternalReferenceDataSystemId) => {
    return api
        .get(`apibymaclearing/haircuts?instance=${instance}&assetExternalReferenceDataSystemId=${assetExternalReferenceDataSystemId}`);
};

const tradeAccountGroups = (instance, client, request) => {
    return api
        .post(`apibymaclearing/tradeAccountGroups?instance=${instance}&client=${client}`, request);
};

const argCvWorkflow = (instance, client, request) => {
    return api
        .post(`apibymaclearing/argCvWorkflow?instance=${instance}&client=${client}`, request);
};

const clearing = {
    haircuts,
    tradeAccountGroups,
    argCvWorkflow
}

export default clearing;